import { Suspense, useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PATHS } from '../../routes/paths';
import Spinner from '../ui/Spinner';

const VENDOR_LINKS = [
{ to: PATHS.vendorDashboard, label: 'Overview', end: true },
{ to: PATHS.vendorListings, label: 'Listings' },
{ to: PATHS.vendorAvailability, label: 'Availability' },
{ to: PATHS.vendorBookings, label: 'Bookings' },
{ to: PATHS.vendorApplications, label: 'Applications' },
{ to: PATHS.vendorOrders, label: 'Orders' },
{ to: PATHS.vendorCredentials, label: 'Credentials' },
{ to: PATHS.vendorPayments, label: 'Payments' },
{ to: PATHS.messages, label: 'Messages' },
{ to: PATHS.vendorSettings, label: 'Settings' }];

const CUSTOMER_LINKS = [
{ to: PATHS.customerDashboard, label: 'Overview', end: true },
{ to: PATHS.customerBookings, label: 'Bookings' },
{ to: PATHS.customerOrders, label: 'Orders' },
{ to: PATHS.customerEvents, label: 'Events' },
{ to: PATHS.customerFavorites, label: 'Favorites' },
{ to: PATHS.messages, label: 'Messages' },
{ to: PATHS.customerSettings, label: 'Settings' }];

export default function DashboardLayout({ role }) {
  const { user } = useAuth();
  const location = useLocation();
  const navRef = useRef(null);
  const links = role === 'vendor' ? VENDOR_LINKS : CUSTOMER_LINKS;

  useEffect(() => {
    const active = navRef.current?.querySelector('[aria-current="page"]');
    if (!active) return;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    active.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [location.pathname]);

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
      <div className="mb-6">
        <p className="text-xs font-bold uppercase tracking-wide text-inksoft">
          {role === 'vendor' ? 'Vendor dashboard' : 'Customer dashboard'}
        </p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">
          Welcome back{user ? `, ${user.name.split(' ')[0]}` : ''}
        </h1>
      </div>
      <div className="grid gap-8 lg:grid-cols-[210px_1fr]">
        <nav ref={navRef} aria-label="Dashboard" className="flex gap-2 overflow-x-auto pb-1 no-scrollbar lg:flex-col">
          {links.map((link) =>
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
            `min-h-11 whitespace-nowrap rounded-xl px-3.5 py-2.5 text-sm font-semibold transition-colors ${
            isActive ? 'bg-ink text-white' : 'text-inksoft hover:bg-panel hover:text-ink'}`

            }>
            
              {link.label}
            </NavLink>
          )}
        </nav>
        <div className="min-w-0">
          <Suspense fallback={<Spinner label="Loading dashboard" />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>);

}
